export default {
    name: 'medianet',
    init() {
        window.advBidxc = window.advBidxc || {};
        // enable refresh across the board. set window.advBidxc.misc.aref = false; to disable
        window.advBidxc.misc = window.advBidxc.misc || {};
        window.advBidxc.timeout = 300;
        window.advBidxc.customerId = "8CU20PT2O"; //Media.net Customer ID
        window.advBidxc.domain = window.location.hostname;
        window.advBidxc.version = 12.1;
        let mnTgts = {
            section: (PageMetadata?.pageSegVars?.ssp || '').toString().trim() || '0', //Publisher's section on the site, eg. pt value 1786, 9890 etc
            site: "webmd" //Publisher's site, eg. webmd
        };
        window.advBidxc.pub = mnTgts;
        if((window.isEmed || window._isAnArticle) && PageMetadata?.reqHeaders?.requestEnv !== 'staging') { // when needed, add back in check for  && hasCtypes.length === 0
          window.advBidxc.misc.aref = true;
        } else{
          window.advBidxc.misc.aref = false;
        }

        function loadScript(tagSrc) {
          var scriptTag = document.createElement('script'),
            placeTag = document.getElementsByTagName("script")[0];
          scriptTag.type = 'text/javascript';
          scriptTag.async = true;
          scriptTag.src = tagSrc;
          placeTag.parentNode.insertBefore(scriptTag, placeTag);
        }

        let mnDn =  'hbx.media.net';

        // Load the primary HB script
        let mnSrc = 'https://' + mnDn + '/bidexchange.js?'
            + 'cid=' + window.advBidxc.customerId
            + "&version=" + window.advBidxc.version
            + '&dn=' + window.advBidxc.domain
            + '&ysite=' + encodeURIComponent(mnTgts.site)
            + '&ysection=' + encodeURIComponent(mnTgts.section);

        loadScript(mnSrc);
    }
};
